import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform, InputAccessoryView, Keyboard } from "react-native";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { searchItems, searchPackagingMaterials, searchInventoryTypes } from "../../actions/records";
import colors from "../../constants/colors";
import { getMinChar, getFirstDiv, getSecondDiv, getThirdDiv, getIosCellHeight, inputFocus } from "../../utils";
import KeyboardBar from "../widgets/KeyboardBar";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
import { DESACTIVATE_PRODUCTCODE_AUTOSELECTION } from "@env";

const isProductCodeAutoSelectionEnabled = (company_id) => {
    if (!DESACTIVATE_PRODUCTCODE_AUTOSELECTION || !company_id) return true;
    const disabledCompanyIds = DESACTIVATE_PRODUCTCODE_AUTOSELECTION
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
    return !disabledCompanyIds.includes(String(company_id));
};

class SearchByProductCode extends Component {
    inputRef = createRef();
    _interval = null;

    constructor(props) {
        super(props);

        this.state = {
            value: props.initial ? props.initial : "",
            supplierSelected: props.initial ? props.initial : "",
            height: 30,
            items: [],
            wasEdited: false,
            height: 50,
            heightIOS: 27,
            filteredSuppliers: [],
            openList: false,
            inputAccessoryViewID: 'productCode-' + props.id + '-' + props?.position,
            scanerCanceled: false,
            softFocus: props.scannerInput ? false : true
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initial != this.props.initial) {
            this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch && !this.inputRef?.current?.isFocused()) {
            this.setState({ items: [], wasEdited: false });
        }
        if (nextProps.focus != this.props.focus && nextProps.focus) {
            inputFocus(this.inputRef)
        }
        //Open Barcode scanner from keyboard text bar (Android)
        if (nextProps.openBarCodeScanner != this.props.openBarCodeScanner && nextProps.openBarCodeScanner) {
            this.showScanner(true);
        }
    }
    componentWillUnmount() {
        if(this._interval) clearTimeout(this._interval);
    }
    formatSuppliers(suppliers) {
        var formatedSuppliers = suppliers.map((sup, idx) => {
            return {
                id: idx + 1,
                value: sup.name
            }
        });

        return formatedSuppliers;
    }
    async handleBarCodeScanned(data) {
        const { onChange, id, options, isShipmentLog, isRecipe, isInvoice, isInventoryTransfer, setOpenBarcode, handleFocusOnElement, type, onSelectItem } = this.props;
        const { value, ingredientOptions } = this.state;
    
        this.setState({ scan: false }, async () => {
            //Activate sound for barcode
            //const { sound } = await Audio.Sound.createAsync(require('../../../assets/audio/scanner-audio.mp3'));
            //await sound.playAsync();
            if (data) {
                this.searchItems(data, type, false, (items) => {
                    if (items?.length) {
                        var item = items.find((i) => i.productCode == data);
                        if (item) {
                            if (isInventoryTransfer && item?.items?.length <= 0 && typeof item?.items == "object") {
                                this.alertConfirm(this.getItemName(item) + " does not have lot codes available to transfer.", "Accept");
                                return;
                            }
                            if (isShipmentLog) {
                                var newItem = JSON.parse(JSON.stringify(item));
                                newItem.lotSelected = ["default_lot"];
                                onSelectItem(item?.productCode, newItem);
                                this.setState({ items: [], value: item?.productCode, wasEdited: false });
                            } else {
                                onSelectItem(item?.productCode, item)
                                this.setState({ items: [], value: item?.productCode, wasEdited: false });
                            }
                        }
                    }
                });
            }
            if (handleFocusOnElement && !isInventoryTransfer) handleFocusOnElement(this.inputRef.current);
        })
    }
    searchItems(val, type, focused, callback) {
        const { onSelectItem, inventoryTypes, resetDropDown, company_id } = this.props;
        if(this._interval)clearTimeout(this._interval);
        if (val || focused) {
            switch (type) {
                case "rawMaterialProductCode":
                    var itemsData = { page: 1, productCode: val };
                    this.props.searchItems(itemsData, (res) => {
                        if (callback) {
                            callback(res.items);
                            return;
                        }else if(val && isProductCodeAutoSelectionEnabled(company_id)){
                            var found = res.items.find(i => i.productCode.trim() == val.trim());
                            if(found){
                                this.autoSelectProductCode(found);
                                return;
                            }
                        }
                        if (res?.items?.length > 0) {
                            this.setState({ items: res?.items });
                        } else {
                            this.setState({ items: [] });
                        }
                        if(resetDropDown)resetDropDown();
                    });
                    break;
                case "packagingProductCode":
                    var itemsData = { page: 1, productCode: val };
                    this.props.searchPackagingMaterials(itemsData, (res) => {
                        if (callback) {
                            callback(res.packagingMaterials);
                            return;
                        }else if(val && isProductCodeAutoSelectionEnabled(company_id)){
                            var found = res.packagingMaterials.find(i => i.productCode.trim() == val.trim());
                            if(found){
                                this.autoSelectProductCode(found);
                                return;
                            }
                        }
                        if (res?.packagingMaterials?.length > 0) {
                            this.setState({ items: res?.packagingMaterials });
                        } else {
                            this.setState({ items: [] });
                        }
                        if(resetDropDown)resetDropDown();
                    });
                    break;
                case "fgProductCode":
                    this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Finished goods", fromApp: true }, (res) => {
                        if (callback) {
                            callback(res.inventoryTypes);
                            return;
                        }else if(val && isProductCodeAutoSelectionEnabled(company_id)){
                            var found = res.inventoryTypes.find(i => i.productCode.toLowerCase().trim() == val.toLowerCase().trim());
                            if(found){
                                this.autoSelectProductCode(found);
                                return;
                            }
                        }

                        if (res?.inventoryTypes?.length > 0) {
                            this.setState({ items: res.inventoryTypes });
                        } else {
                            this.setState({ items: [] });
                        }
                        if(resetDropDown)resetDropDown();
                    });
                    break;
                case "wipProductCode":
                    this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Work in progress", fromApp: true }, (res) => {
                        if (callback) {
                            callback(res.inventoryTypes);
                            return;
                        }else if(val && isProductCodeAutoSelectionEnabled(company_id)){
                            var found = res.inventoryTypes.find(i => i.productCode.trim() == val.trim());
                            if(found){
                                this.autoSelectProductCode(found);
                                return;
                            }
                        }

                        if (res?.inventoryTypes?.length > 0) {
                            this.setState({ items: res.inventoryTypes });
                        } else {
                            this.setState({ items: [] });
                        }
                        if(resetDropDown)resetDropDown();
                    });
                    break;
            }
        } else {
            this.setState({ items: [] });
        }
        onSelectItem(val, null);
    }
    serchInInventoryTypes(value, type, inventoryTypes) {
        var types = inventoryTypes.filter(inventory => {
            if (inventory?.productCode) {
                var productCode = inventory.productCode.toLowerCase();
                return inventory.inventoryType == type && productCode.includes(value.toLowerCase());
            } else {
                return false;
            }
        });
        if (types.length > 10) {
            types = types.slice(0, 10);
        }
        return types;
    }
    alertConfirm(msg, conf) {
        Swal.fire({
            text: msg,
            confirmButtonText: conf,
            confirmButtonColor: "#0B4DA0",
            backdrop: false,
        });
    }
    getItemName(item) {
        var name = item.itemName ? item.itemName : item.item ? item.item : item.namePackaging ? item.namePackaging : "";
        return name;
    }
    showScanner(value) {
        this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled });
    }
    showScannerInput() {
        const { setFormScroll } = this.props;
        if (!this.state.scanerCanceled) {
            if (setFormScroll) setFormScroll(false);
            setTimeout(() => {
                this.showScanner(true);
                setTimeout(() => {
                    if (setFormScroll) setFormScroll(true);
                }, 300);
            }, 500);
        } else {
            this.setState({ scanerCanceled: false });
        }
    }
    autoSelectProductCode(item){
        const { isShipmentLog, onSelectItem } = this.props;
        if (isShipmentLog) {
            var newItem = JSON.parse(JSON.stringify(item));
            newItem.lotSelected = ["default_lot"];
            onSelectItem(item?.productCode, newItem);
            this.setState({ items: [], value: item?.productCode, wasEdited: false });
        } else {
            onSelectItem(item?.productCode, item)
            this.setState({ items: [], value: item?.productCode, wasEdited: false });
        }
    }
    render() {
        const { value, items, wasEdited, filteredSuppliers, openList, scan, scanerCanceled, softFocus } = this.state;
        const { defaultComponent, onSelectItem, width, onFocus, placeholder, type, isShipmentLog, isInventoryTransfer, isInventoryReceivingForm, inventoryTableDesign, isReceivingLog, handleFocusOnElement, setShowTextBar, id, position, ingredientName, units, amount, scannerInput, showScanner } = this.props;
        const scannerFieldForInput = showScanner || isInventoryReceivingForm || (isInventoryTransfer && scannerInput);
        const inventoryTableCellDesign = !!(isInventoryReceivingForm || inventoryTableDesign);

        //if (scan) {
        //    return 
        //}
        return <View>
            {
                scan ?
                    <View style={{
                        ...styles.container,
                        paddingTop: width ? 0 : 5
                    }}>
                        <BarcodeScannerComponent
                            onBarCodeScanned={(e) => this.handleBarCodeScanned(e)}
                            closeScanner={() => {
                                this.showScanner(false);
                                if (scannerInput && scannerFieldForInput) {
                                    this.setState({ scanerCanceled: true }, () => {
                                        setTimeout(() => {
                                            if (inputFocus) inputFocus(this.inputRef);
                                        }, 500);
                                    });
                                }
                            }}
                            style={styles.absoluteFillObject}
                        />
                    </View> :
                    <View>
                        <View>
                            <TextInput
                                {...getNoAutofillProps()}
                                ref={noAutofillRef(this.inputRef)}
                                value={value}
                                editable={!defaultComponent && !(scannerInput && scannerFieldForInput && !value && !scanerCanceled && Platform.OS == "ios")}
                                showSoftInputOnFocus={Platform.OS == "ios" ? true : softFocus}
                                onPress={() => {
                                    if (Platform.OS == "ios" && scannerInput && scannerFieldForInput && !value && !scanerCanceled) {
                                        this.showScannerInput();
                                    }
                                }}
                                onFocus={() => {
                                    if (Platform.OS != "ios" && scannerInput && scannerFieldForInput && !value && !scanerCanceled) {
                                        this.showScannerInput();
                                        if(!softFocus){
                                            this.setState({ softFocus: true });
                                            return;
                                        }
                                    }
                                    /* Same idea as lotcode: after cancel, parent Input would reopen scanner on this focus — skip once. Next session: blur resets scanerCanceled, then focus opens scanner again. */
                                    const skipParentScannerReopen = scannerInput && showScanner && scannerFieldForInput && !value && scanerCanceled;
                                    if (onFocus) {
                                        if (skipParentScannerReopen) {
                                            setTimeout(() => {
                                                if (handleFocusOnElement && this.inputRef?.current) {
                                                    handleFocusOnElement(this.inputRef.current);
                                                }
                                            }, 300);
                                        } else {
                                            onFocus();
                                        }
                                    }
                                    if(!value){
                                        if(this._interval)clearTimeout(this._interval);
                                        this._interval = setTimeout(() => this.searchItems("", type, true, false), 500);
                                    }
                                    /* Mobile web Form KeyboardBar (ABC/scan): all product-code contexts, not only shipment/receiving */
                                    if (setShowTextBar && isMobileWeb()) {
                                        setShowTextBar(id, position, [], null, null, null, null, false, true);
                                    }
                                }}
                                onBlur={() => {
                                    /* lotcode.js: blur clears cancel so a later focus can open the scanner again */
                                    if (scannerInput && scannerFieldForInput) {
                                        this.setState({ scanerCanceled: false });
                                        if (softFocus) this.setState({ softFocus: false });
                                    }
                                    if (setShowTextBar && isMobileWeb()) {
                                        setShowTextBar(null, null, null, null, null, null, null, false);
                                    }
                                }}
                                onContentSizeChange={(event) => {
                                    //if (Platform.OS == 'ios') {
                                    //  this.setState({ heightIOS: event.nativeEvent.contentSize.height });
                                    //} else {
                                    //  this.setState({ height: event.nativeEvent.contentSize.height });
                                    //} 
                                }}
                                inputAccessoryViewID={this.state.inputAccessoryViewID}
                                style={{
                                    ...styles.input,
                                    borderColor: "#e7e7e7",
                                    borderRadius: 5,
                                    borderWidth: inventoryTableCellDesign ? 0 : 1,
                                    color: "#424242",
                                    fontFamily: "Roboto",
                                    fontSize: inventoryTableCellDesign ? 16 : 20,
                                    fontWeight: "400",
                                    height:
                                        Platform.OS === 'ios' ?
                                            this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
                                            this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
                                    //Android
                                    //  this.state.value == "" || !this.state.value
                                    //    ? this.props.placeholder && this.props.placeholder.length >= getMinChar(width)
                                    //      ? this.props.placeholder.length <= 50 ?
                                    //        (this.state.height * (this.props.placeholder.length / getFirstDiv(width)))
                                    //        : this.props.placeholder.length <= 200 ?
                                    //          (this.state.height * (this.props.placeholder.length / getSecondDiv(width)))
                                    //          : (this.state.height * (this.props.placeholder.length / getThirdDiv(width)))
                                    //      : this.state.height
                                    //    : (this.state.value.length / 31) <= 0 ? (this.state.height * (this.state.value.length / 28))
                                    //      : this.state.height,
                                    fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                                    textAlign: inventoryTableCellDesign ? 'center' : 'left',
                                }}
                                multiline={true}
                                placeholder={placeholder}
                                placeholderTextColor={'rgb(0, 47, 108)'}
                                onChangeText={(val) => {
                                    if (val != value) {
                                        if (val == '' && this.props.placeholder == '') {
                                            this.setState({ value: val, height: 30, wasEdited: true });

                                        } else {
                                            this.setState({ value: val, wasEdited: true });
                                        }
                                        if(this._interval)clearTimeout(this._interval);
                                        this._interval = setTimeout(() => this.searchItems(val, type, false, false), 500);
                                    }
                                }}
                            />
                            {Platform.OS == "ios" && <InputAccessoryView nativeID={this.state.inputAccessoryViewID}>
                                {(isShipmentLog || isReceivingLog) && <KeyboardBar abcOptionPress={null} scanOptionPress={() => {
                                    this.showScanner(true);
                                    //setTimeout(() => {
                                    //    if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                                    //}, 300);
                                }} />}
                            </InputAccessoryView>}
                        </View>
                        <View style={{ padding: 5 }}>
                            {
                                items.map((item, index) => {
                                    return <TouchableOpacity key={index} style={styles.row} onPress={() => {
                                        if (isInventoryTransfer && item?.items?.length <= 0 && typeof item?.items == "object") {
                                            this.alertConfirm(this.getItemName(item) + " does not have lot codes available to transfer.", "Accept");
                                            return;
                                        }
                                        if (isShipmentLog) {
                                            var newItem = JSON.parse(JSON.stringify(item));
                                            newItem.lotSelected = ["default_lot"];
                                            onSelectItem(item?.productCode, newItem);
                                            this.setState({ items: [], value: item?.productCode, wasEdited: false });
                                        } else {
                                            onSelectItem(item?.productCode, item)
                                            this.setState({ items: [], value: item?.productCode, wasEdited: false });
                                        }
                                    }}>
                                        <View style={styles.txt1}>
                                            <Text>
                                                {item?.productCode}
                                            </Text>
                                        </View>
                                        <View>
                                            <TouchableOpacity style={styles.rowBtn} onPress={() => {
                                                if (isInventoryTransfer && item?.items?.length <= 0 && typeof item?.items == "object") {
                                                    this.alertConfirm(this.getItemName(item) + " does not have lot codes available to transfer.", "Accept");
                                                    return;
                                                }
                                                if (isShipmentLog) {
                                                    var newItem = JSON.parse(JSON.stringify(item));
                                                    newItem.lotSelected = ["default_lot"];
                                                    onSelectItem(item?.productCode, newItem);
                                                    this.setState({ items: [], value: item?.productCode, wasEdited: false });
                                                } else {
                                                    onSelectItem(item?.productCode, item)
                                                    this.setState({ items: [], value: item?.productCode, wasEdited: false });
                                                }
                                            }}>
                                                <Text style={{ color: colors.userCommand }}>
                                                    +
                                                </Text>
                                            </TouchableOpacity>
                                        </View>
                                    </TouchableOpacity>
                                })
                            }
                        </View>
                        {
                            value && items?.length <= 0 && wasEdited && <View>
                                <Text>No {'items'} were found</Text>
                            </View>
                        }
                    </View>

            }
        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
    company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
    searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
    searchPackagingMaterials: (data, callback) =>
        dispatch(searchPackagingMaterials(data, callback)),
    searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
}))(SearchByProductCode);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400"
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        flex: 1,
        flexDirection: "row",
        padding: 5,
        width: "100%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        borderRadius: 4,
        padding: 5,
        borderWidth: 1,
        borderColor: colors.userCommand,
    },
    txt1: {
        flex: 3,
    },
    absoluteFillObject: {
        height: 400,
        width: "100%",
    },
});